import React, { useState } from "react";
import PropTypes from "prop-types";
import Card from "../instances/Card";
//import Intro from "../common/Intro"
//import Media from "../instances/Media"
import Person from "../instances/Person";
import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";
//import Text from "../instances/Text";

/********************************
<Columns />
/********************************
Version: 2
Created: 12 08 2023
Updated: 23 01 2025
Author: Richy Pears
/********************************
A generic use section for displaying
a number of instances in columns
which are controlled by Storyblok
/********************************/

const Columns = ({ blok }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  if (!blok) return null; // Escape hatch
  const {
    copy,
    columns,
    items,
    number,
    padding,
    rounded,
    subtitle,
    theme,
    title,
  } = blok;

  const colour = SmartColour(theme);

  const randomId = "brand_controller_" + Math.floor(Math.random() * 100) + 1; // Random string created for unique ID

  return (
    <section
      className={`flex flex-col ${
        colour.classes && colour.classes
      } ${SmartStyles("padding", padding)} ${SmartStyles("rounded", rounded)}`}
    >
      <div className="brand-container flex flex-col gap-5 md:gap-10">
        <SectionNumber title={subtitle && subtitle} number={number && number} />
        {title && <h1 className="m-0 text-center">{title}</h1>}
        {copy?.content[0]?.content && (
          <SmartText className="m-0 text-center brand-remove-last-margin">
            {copy}
          </SmartText>
        )}
        <div
          className={`flex flex-row${
            columns?.xs !== "auto" ? " flex-wrap" : " flex-nowrap"
          }${columns?.sm !== "auto" ? " sm:flex-wrap" : " sm:flex-nowrap"}${
            columns?.md !== "auto" ? " md:flex-wrap" : " md:flex-nowrap"
          }${columns?.lg !== "auto" ? " lg:flex-wrap" : " lg:flex-nowrap"}${
            columns?.xl !== "auto" ? " xl:flex-wrap" : " xl:flex-nowrap"
          } items-stretch justify-center w-auto h-full -mx-3`}
        >
          {items &&
            items.map((node, index) => {
              if (node.component === "instance_card") {
                return (
                  <Card
                    columns={columns}
                    node={node && node}
                    theme={colour.text && colour.text}
                  />
                );
              } else if (node.component === "instance_media") {
                //                return <Media columns={columns} node={node && node} />;
              } else if (node.component === "instance_person") {
                return <Person columns={columns} node={node && node} />;
              } else if (node.component === "instance_text") {
                //                return <Text columns={columns} node={node && node} />;
              }
              return <div className="border">ITEM</div>;

              return null;
            })}
        </div>
      </div>
    </section>
  );
};

export default Columns;

Columns.defaultProps = {
  blok: null,
};

Columns.propTypes = {
  blok: PropTypes.object,
};
